import { apiRequest, trickleCreateObject, trickleDeleteObject, trickleListObjects, trickleUpdateObject } from "./api";

export async function saveToHistory(data) {
    try {
        const userId = getUserId();
        if (!userId) {
            throw new Error('User not authenticated');
        }
        
        // Prepare history record data
        const historyData = {
            source: data.url,
            content: data.content,
            type: data.type
        };
        
        // Create history record in storage
        const result = await apiRequest('POST', '/api/index/saveHistory', historyData);
        if (result.success) {
            return {
                id: result.id,
                ...historyData
            };
        } else {
            throw new Error(result.error)
        }
    } catch (error) {
        console.error('Failed to save history record:', error);
        throw error;
    }
}

export async function getHistory() {
    try {
        const userId = getUserId();
        if (!userId) {
            throw new Error('User not authenticated');
        }
        
        const result = await apiRequest('POST', '/api/index/getHistory')

        if (!result.success) {
            throw new Error(result.error);
        }
        
        return result.data.items;
    } catch (error) {
        console.error('Failed to get history:', error);
        throw error;
    }
}

export async function clearHistory() {
    try {
        const userId = getUserId();
        if (!userId) {
            throw new Error('User not authenticated');
        }
        
        const historyObjectType = `history:${userId}`;
        const result = await trickleListObjects(historyObjectType, 100, true);
        
        // Delete all history records
        const deletePromises = result.items.map(item => 
            trickleDeleteObject(historyObjectType, item.objectId)
        );
        
        await Promise.all(deletePromises);
        
        return true;
    } catch (error) {
        console.error('Failed to clear history:', error);
        throw error;
    }
}

export async function updateHistoryRecord(recordId, updatedData) {
    try {
        const userId = getUserId();
        if (!userId) {
            throw new Error('User not authenticated');
        }

        const result = await apiRequest('POST', '/api/index/updateHistory', {
            id: recordId,
            rewrite_result: updatedData.rewrite_result,
        })
        if (!result.success) {
            throw new Error(result.error);
        }
        
        return result.data;
    } catch (error) {
        console.error('Failed to update history record:', error);
        throw error;
    }
}

export async function updateRewriteResult(resultId, content) {
    try {
        const userId = getUserId();
        if (!userId) {
            throw new Error('User not authenticated');
        }

        const result = await apiRequest('POST', '/api/index/updateRewriteResult', {
            id: resultId,
            content: content,
        })
        if (!result.success) {
            throw new Error(result.error);
        }
        
        return result.data;
    } catch (error) {
        console.error('Failed to update history record:', error);
        throw error;
    }
}

function getUserId() {
    try {
        const userData = localStorage.getItem('user');
        if (!userData) return null;
        
        const user = JSON.parse(userData);
        return user.id;
    } catch (error) {
        console.error('Failed to get user ID:', error);
        return null;
    }
}
